import { textFunctions } from "../common/constants/functions/textFunctions";
import { setUbicationData, setUbicationIDData } from "../common/constants/interfaces/UbicationInterface";
;
export class Search {
    constructor() {
        this.attributesList = false;
        this.collectionList = false;
        this.idCollection = '';
        this.locationsReady = false;
        this.searchToken = 0;
        this.data = {
            search_txt: '',
            tipo_select: 0,
            valueText: '',
            tipo_text: 'Tipo',
            results: [],
            facets: {
                city: [],
                zone: [],
                sector: [],
                department: [],
            }
        };
        this.functions = new textFunctions();
        this.searchInput = document.getElementById('searchHomeInput');
        this.searchButton = document.getElementById('js-home-search-btn');
        this.searchTextButton = document.getElementById('js-search-text');
        this.homeList = document.getElementById('homeList');
        const homeInput = document.getElementById('searchHomeInput');
        const navInput = document.getElementById('searchNavigationInput');
        if (homeInput && document.getElementById('homeList')) {
            this.searchInput = homeInput;
            this.homeList = document.getElementById('homeList');
            this.bindToCurrentInput();
        }
        else if (navInput && document.getElementById('navSearchResultsList')) {
            this.searchInput = navInput;
            this.homeList = document.getElementById('navSearchResultsList');
            this.bindToCurrentInput();
        }
        this.setInputId = this.setInputId.bind(this);
        this.search_txt = this.search_txt.bind(this);
        this.changeTipo = this.changeTipo.bind(this);
        this.redirectFirstResult = this.redirectFirstResult.bind(this);
        this.keyActionUpDown = this.keyActionUpDown.bind(this);
        this.search_onInput = this.search_onInput.bind(this);
        this.search_onKeyDown = this.search_onKeyDown.bind(this);
        this.addEventListeners();
        window.countlia = 0;
        const w = window;
        w.evSearch = this;
        w.setInputId = (listId, inputId) => w.evSearch.setInputId(listId, inputId);
        w.changeTipo = (e) => w.evSearch.changeTipo(e);
    }
    /**
     * Set the input ID and the list to be used for search results.
     * @param {string} inputId - The input field ID.
     * @param {string} listId - The results list ID.
     * @returns {void}
     */
    setInputId(listId, inputId) {
        const input = document.getElementById(inputId);
        const list = document.getElementById(listId);
        const whiteBrand = document.getElementById('idWhiteBrand');
        const pathname = window.location.pathname;
        if (!input || !list)
            return;
        this.searchInput = input;
        this.homeList = list;
        this.attributesList = listId.includes('selectList');
        this.collectionList = listId.includes('collectionList');
        if (this.collectionList) {
            const idWhiteBrand = whiteBrand ? whiteBrand.getAttribute('data-id') : '';
            this.idCollection = pathname.includes('feria-propia/camacol-fest') ? 'collection=33766' : 'white_brand=' + idWhiteBrand;
        }
        this.bindToCurrentInput();
    }
    bindToCurrentInput() {
        // evita re-binds infinitos
        if (this.searchInput.dataset.bound === '1')
            return;
        this.searchInput.dataset.bound = '1';
        this.search_onInput = this.search_onInput.bind(this);
        this.search_onKeyDown = this.search_onKeyDown.bind(this);
        this.searchInput.addEventListener('input', this.search_onInput);
        this.searchInput.addEventListener('keydown', this.search_onKeyDown);
    }
    /**
     * Change the search type and update search options accordingly.
     * @param {Event} type - The search type (e.g., 'apartment', 'house').
     * @returns {void}
     */
    async changeTipo(e) {
        const selectValue = e.target.value;
        this.updateTabs(selectValue);
        this.updateTipoSelect(selectValue);
        this.searchToken++;
        const token = this.searchToken;
        await this.loadLocation(this.stringTipo(this.data.tipo_select)).catch(() => { });
        if (token !== this.searchToken)
            return;
        const text = (this.data.valueText || '').trim();
        if (text.length > 2) {
            await this.getSearch(text);
        }
        else {
            this.data.results = [];
            this.removeSearchLoader();
            this.renderList([]);
        }
    }
    /**
     * Ensures location facets are loaded once and memoizes the request.
     * Prevents duplicate API calls before running local search.
     *
     * @returns {Promise<void>}
     */
    ensureLocationsLoaded() {
        if (this.locationsReady)
            return Promise.resolve();
        if (!this.locationsPromise) {
            this.locationsPromise = this.loadLocation('all')
                .then(() => { this.locationsReady = true; })
                .catch(() => { this.locationsReady = false; })
                .finally(() => { });
        }
        return this.locationsPromise;
    }
    /**
   * Initializes the search module.
   * Ensures location facets are loaded before any search is executed.
   *
   * @returns {Promise<void>}
   */
    async init() {
        await this.ensureLocationsLoaded();
    }
    /**
     * Update the active tab based on the selected search type.
     * @param {string} tipo - The search type used to determine which tab to activate.
     * @returns {void}
     */
    updateTabs(tipo) {
        const tabsHome = Array.from(document.getElementsByClassName('home-tabs__item__link'));
        tabsHome.forEach((tab) => {
            if (tab === (event === null || event === void 0 ? void 0 : event.target)) {
                tab.classList.add('active');
            }
            else {
                tab.classList.remove('active');
            }
        });
    }
    /**
     * Update the selected type based on the chosen search type.
     * @param {string} tipo - The selected search type.
     * @returns {void}
     */
    updateTipoSelect(tipo) {
        const placeholderBase = 'Ingresa la ciudad, zona o sector de tu ';
        const btnSuffixText = " en Colombia";
        switch (tipo) {
            case 'todos':
                this.data.tipo_text = 'Todos';
                this.data.tipo_select = 0;
                this.searchInput.placeholder = placeholderBase + 'Inmueble';
                this.searchTextButton.textContent = 'Buscar Inmuebles' + btnSuffixText;
                this.searchButton.setAttribute('href', '/proyectos-vivienda');
                break;
            case 'apartamento':
                this.data.tipo_text = 'Apartamento';
                this.data.tipo_select = 10961;
                this.searchInput.placeholder = placeholderBase + 'Apartamento';
                this.searchTextButton.textContent = 'Buscar Apartamentos' + btnSuffixText;
                this.searchButton.setAttribute('href', '/apartamentos');
                break;
            case 'apartaestudio':
                this.data.tipo_text = 'Apartaestudio';
                this.data.tipo_select = 10963;
                this.searchInput.placeholder = placeholderBase + 'Apartaestudio';
                this.searchTextButton.textContent = 'Buscar Apartaestudios' + btnSuffixText;
                this.searchButton.setAttribute('href', '/apartaestudios');
                break;
            case 'casa':
                this.data.tipo_text = 'Casa';
                this.data.tipo_select = 10962;
                this.searchInput.placeholder = placeholderBase + 'Casa';
                this.searchTextButton.textContent = 'Buscar Casas' + btnSuffixText;
                this.searchButton.setAttribute('href', '/casas');
                break;
            case 'lote':
                this.data.tipo_text = 'Lote';
                this.data.tipo_select = 10964;
                this.searchInput.placeholder = placeholderBase + 'Lote';
                this.searchTextButton.textContent = 'Buscar Lotes' + btnSuffixText;
                this.searchButton.setAttribute('href', '/lotes');
                break;
            default:
                break;
        }
    }
    /**
     * Converts the selected type into a string for use in the query.
     * @param {number} tipo - The numerical search type.
     * @returns {string} - The string representation of the search type.
     */
    stringTipo(tipo) {
        return tipo !== 0 ? `type=${tipo}` : 'all';
    }
    /**
     * Fetches location facets (city, sector, department) and stores them
     * for local search suggestions.
     *
     * @param {string} tipo Query fragment used to filter locations (e.g. "type=10964" or "all").
     * @returns {Promise<void>}
     */
    async loadLocation(tipo) {
        var _a, _b, _c, _d;
        const params = [];
        if (tipo && tipo !== 'all')
            params.push(tipo);
        if (this.collectionList)
            params.push(this.idCollection);
        const urlApi = `/api/ev-results-search${params.length ? `?${params.join('&')}` : ''}`;
        const res = await fetch(urlApi);
        const finalRes = await res.json();
        this.data.facets['city'] = (_a = finalRes.facetas.project_city) !== null && _a !== void 0 ? _a : [];
        this.data.facets['zone'] = (_b = finalRes.facetas.project_zone) !== null && _b !== void 0 ? _b : [];
        this.data.facets['sector'] = (_c = finalRes.facetas.project_neighborhood) !== null && _c !== void 0 ? _c : [];
        this.data.facets['department'] = (_d = finalRes.facetas.field_location_department) !== null && _d !== void 0 ? _d : [];
    }
    /**
     * Handles the change event for search input and triggers the search.
     * @param {Event} val - The event triggered by the search input.
     * @returns {void}
     */
    search_txt(e) {
        // Si viene keydown, navega; si viene input, busca
        if (e instanceof KeyboardEvent)
            this.search_onKeyDown(e);
        else
            this.search_onInput(e);
    }
    search_onInput(e) {
        var _a, _b, _c, _d;
        const parent = (_a = this.homeList) === null || _a === void 0 ? void 0 : _a.parentElement;
        const value = (((_b = e.target) === null || _b === void 0 ? void 0 : _b.value) || '').trim().toLowerCase();
        if (value.length <= 2) {
            this.searchToken++;
            this.data.valueText = value;
            this.data.results = [];
            this.removeSearchLoader();
            this.renderList([]);
            (_c = this.homeList) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
            (_d = parent === null || parent === void 0 ? void 0 : parent.querySelector('.js-search-loader')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
            window.countlia = 0;
            return;
        }
        void this.getSearch(value);
    }
    search_onKeyDown(e) {
        if (e.key === 'Enter') {
            this.redirectFirstResult(e);
            return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault(); // evita mover el cursor en algunos móviles
            this.keyActionUpDown(e);
        }
    }
    /**
   * Displays the search loader UI while remote results are being fetched.
   * Shows loader elements and adjusts result list positioning.
   *
   * @returns {void}
   */
    addSearchLoader() {
        var _a, _b, _c, _d, _e;
        if (!this.homeList)
            return;
        const parent = this.homeList.parentElement;
        if (!parent)
            return;
        if (document.getElementById('searchRings') && document.getElementById('searchLoaderText')) {
            document.getElementById('searchRings').classList.remove('d-none');
            document.getElementById('searchLoaderText').textContent = 'Buscando Proyectos y Constructoras';
        }
        (_a = parent.querySelector('.js-search-loader')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        (_b = parent.querySelector('.js-search-loader')) === null || _b === void 0 ? void 0 : _b.classList.add('d-block');
        if (!this.homeList.classList.contains('search__results-list--form ')) {
            (_c = this.homeList) === null || _c === void 0 ? void 0 : _c.classList.add('top-74');
            (_d = this.homeList) === null || _d === void 0 ? void 0 : _d.classList.remove('mt');
            (_e = this.homeList) === null || _e === void 0 ? void 0 : _e.classList.remove('top-46');
        }
    }
    /**
   * Hides the search loader UI after results are loaded.
   * Restores result list layout to its default state.
   *
   * @returns {void}
   */
    removeSearchLoader() {
        var _a, _b, _c, _d, _e;
        const parent = this.homeList.parentElement;
        if (!parent)
            return;
        (_a = parent.querySelector('.js-search-loader')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-block');
        (_b = parent.querySelector('.js-search-loader')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        if (!this.homeList.classList.contains('search__results-list--form')) {
            (_c = this.homeList) === null || _c === void 0 ? void 0 : _c.classList.remove('top-74');
            (_d = this.homeList) === null || _d === void 0 ? void 0 : _d.classList.remove('mt');
            (_e = this.homeList) === null || _e === void 0 ? void 0 : _e.classList.add('top-46');
        }
    }
    /**
     * Redirects to the URL of the first result in the list if specific conditions are met.
     *
     * @param {KeyboardEvent} event - The keyboard event that triggers the method.
     * @return {void} This method does not return a value.
     */
    redirectFirstResult(event) {
        var _a;
        if (this.data.results.length > 0 && ((_a = this.homeList) === null || _a === void 0 ? void 0 : _a.classList.contains('d-block'))) {
            let lia = this.homeList.querySelector('li a');
            if (lia.getAttribute('on-focus-visited') != '1') {
                lia.style.backgroundColor = '#EFF7C5';
                window.location.href = this.data.results[0].url;
            }
            else {
                window.location.href = this.data.results[window.countlia - 1].url;
            }
        }
    }
    /**
     * Handles the "ArrowUp" and "ArrowDown" keyboard events to navigate through a list of items in the DOM, applying visual changes to highlight the selected item.
     *
     * @param {KeyboardEvent} event - The keyboard event object containing information about the key pressed.
     * @return {void} No value is returned by this method. It updates the DOM based on user interactions.
     */
    keyActionUpDown(event) {
        const lia = document.querySelectorAll('#homeList li a');
        const size = lia.length;
        if (!size)
            return;
        if (event.key === 'ArrowDown')
            window.countlia++;
        if (event.key === 'ArrowUp')
            window.countlia--;
        window.countlia = Math.max(1, Math.min(window.countlia, size));
        const idx = window.countlia - 1;
        const current = lia[idx];
        if (!current)
            return;
        lia.forEach(el => {
            el.removeAttribute('style');
            el.removeAttribute('on-focus');
        });
        current.style.backgroundColor = '#EFF7C5';
        current.setAttribute('on-focus', '1');
        const container = document.getElementById('homeList');
        if (container) {
            const cTop = container.scrollTop;
            const cBottom = cTop + container.clientHeight;
            const eTop = current.offsetTop;
            const eBottom = eTop + current.offsetHeight;
            if (eTop < cTop)
                container.scrollTop = eTop;
            if (eBottom > cBottom)
                container.scrollTop = eBottom - container.clientHeight;
        }
    }
    /**
     * Executes the header search flow.
     * Renders local matches first and then fetches remote results.
     * Uses a search token to avoid race conditions.
     *
     * @param {string} text User input text.
     * @returns {Promise<void>}
     */
    async getSearch(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const trimmed = text.trim();
        if (trimmed.length <= 2) {
            this.searchToken++;
            this.data.results = [];
            this.removeSearchLoader();
            this.renderList([]);
            return;
        }
        const token = ++this.searchToken;
        if (!this.locationsReady) {
            await this.ensureLocationsLoaded();
            if (token !== this.searchToken)
                return;
        }
        this.data.valueText = trimmed;
        (_a = this.homeList) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        (_b = this.homeList) === null || _b === void 0 ? void 0 : _b.classList.add('d-block');
        const q = this.functions.formatText(trimmed);
        const facets = (_c = this.data.facets) !== null && _c !== void 0 ? _c : { city: [], sector: [], department: [] };
        const cityMatches = ((_d = facets['city']) !== null && _d !== void 0 ? _d : []).filter((x) => this.functions.formatText(x.label).includes(q));
        const sectorMatches = ((_e = facets['sector']) !== null && _e !== void 0 ? _e : []).filter((x) => this.functions.formatText(x.label).includes(q));
        const departmentMatches = ((_f = facets['department']) !== null && _f !== void 0 ? _f : []).filter((x) => this.functions.formatText(x.label).includes(q));
        const localItems = this.dedupeItems([
            ...this.buildCitiesResults(cityMatches),
            ...this.buildSectorResults(sectorMatches),
            ...this.buildDepartmentResults(departmentMatches),
        ]);
        if (token !== this.searchToken)
            return;
        this.data.results = localItems.slice();
        this.renderList(this.data.results);
        const shouldFetchRemote = !this.attributesList && !this.collectionList;
        if (!shouldFetchRemote)
            return;
        this.addSearchLoader();
        const settled = await Promise.allSettled([
            this.fetchTypologiesItems(trimmed, token),
            this.fetchBuildersItems(trimmed, token),
        ]);
        if (token !== this.searchToken)
            return;
        const remoteItems = [];
        const [typosRes, buildersRes] = settled;
        if (typosRes.status === 'fulfilled')
            remoteItems.push(...typosRes.value);
        if (buildersRes.status === 'fulfilled')
            remoteItems.push(...buildersRes.value);
        if (remoteItems.length) {
            this.data.results = this.dedupeItems([...localItems, ...remoteItems]);
            this.renderList(this.data.results);
            this.removeSearchLoader();
        }
        else {
            if (document.getElementById('searchRings') && document.getElementById('searchLoaderText')) {
                document.getElementById('searchRings').classList.add('d-none');
                document.getElementById('searchLoaderText').textContent = 'No hay Proyectos o Constructoras que coincidan con tu búsqueda';
            }
            (_g = this.homeList) === null || _g === void 0 ? void 0 : _g.classList.add('top-74');
            (_h = this.homeList) === null || _h === void 0 ? void 0 : _h.classList.add('mt');
        }
    }
    /**
     * Adds department results to the search result list.
     * @param {Facet[]} list_department - The list of departments.
     * @returns {void}
     */
    buildDepartmentResults(list_department) {
        var _a, _b, _c, _d, _e, _f;
        const out = [];
        const seen = new Set();
        const allCities = (_b = (_a = this.data.facets) === null || _a === void 0 ? void 0 : _a['city']) !== null && _b !== void 0 ? _b : [];
        for (const dept of list_department) {
            if (!dept)
                continue;
            const deptTid = (_e = (_d = (_c = dept.tid) === null || _c === void 0 ? void 0 : _c.toString) === null || _d === void 0 ? void 0 : _d.call(_c)) !== null && _e !== void 0 ? _e : String(dept.tid);
            const listCity = allCities.filter((x) => this.functions.formatText(String(x.parent)) === this.functions.formatText(deptTid));
            for (const city of listCity) {
                if (!city || city.count === 0)
                    continue;
                const url = this.updateUrlForTipoSelect(city.url);
                const key = `dept-city|${(_f = city.tid) !== null && _f !== void 0 ? _f : city.label}|${url}`;
                if (seen.has(key))
                    continue;
                seen.add(key);
                out.push({
                    title: city.label,
                    url,
                    subtitle: '',
                    iconUrl: '/themes/custom/ev_theme/assets/images/search_icons/search-icon-location-green.png',
                });
            }
        }
        return out;
    }
    /**
     * Adds city results to the search result list.
     * @param {Facet[]} list_city - The list of cities.
     * @returns {void}
     */
    buildCitiesResults(list_city) {
        var _a;
        const out = [];
        const seen = new Set();
        for (const item of list_city) {
            if (!item || item.count === 0)
                continue;
            const url = this.updateUrlForTipoSelect(item.url);
            const key = `city|${(_a = item.tid) !== null && _a !== void 0 ? _a : item.label}|${url}`;
            if (seen.has(key))
                continue;
            seen.add(key);
            out.push({
                title: item.label,
                url,
                subtitle: '',
                iconUrl: '/themes/custom/ev_theme/assets/images/search_icons/search-icon-location-green.png',
            });
        }
        return out;
    }
    /**
     * Adds sector results to the search result list.
     * @param {Facet[]} list_sector - The list of sectors.
     * @returns {void}
     */
    buildSectorResults(list_sector) {
        var _a;
        const out = [];
        const seen = new Set();
        for (const item of list_sector) {
            if (!item)
                continue;
            const url = this.updateUrlForTipoSelect(item.url);
            const subtitle = this.subTitleSector(item.tid);
            const key = `sector|${(_a = item.tid) !== null && _a !== void 0 ? _a : item.label}|${url}`;
            if (seen.has(key))
                continue;
            seen.add(key);
            out.push({
                title: item.label,
                url,
                subtitle,
                iconUrl: '/themes/custom/ev_theme/assets/images/search_icons/search-icon-location-green.png',
            });
        }
        return out;
    }
    /**
   * Removes duplicated search items based on subtitle, title and url.
   * Keeps the first occurrence and preserves original order.
   *
   * @param {SearchItem[]} items List of items to deduplicate.
   * @returns {SearchItem[]} New array without duplicates.
   */
    dedupeItems(items) {
        const seen = new Set();
        const out = [];
        for (const it of items) {
            const key = `${it.subtitle}|${it.title}|${it.url}`;
            if (seen.has(key))
                continue;
            seen.add(key);
            out.push(it);
        }
        return out;
    }
    /**
     * Adds typology project results to the search result list.
     * @param {string} text - The search text entered by the user.
     * @returns {Promise<void>}
     */
    async fetchTypologiesItems(text, token) {
        var _a;
        const params = [`text=${encodeURIComponent(text)}`];
        const tipo = this.stringTipo(this.data.tipo_select);
        if (tipo && tipo !== 'all')
            params.push(tipo);
        const url = `/api/ev-results-search-project?${params.join('&')}`;
        let res;
        try {
            res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        }
        catch (e) {
            return [];
        }
        if (token !== this.searchToken)
            return [];
        if (!res.ok) {
            return [];
        }
        let data;
        try {
            data = await res.json();
        }
        catch {
            return [];
        }
        const items = ((_a = data === null || data === void 0 ? void 0 : data.Items) !== null && _a !== void 0 ? _a : []).map((item) => ({
            title: item.field_name,
            url: item.field_url,
            subtitle: 'Proyecto',
            iconUrl: '/themes/custom/ev_theme/assets/images/search_icons/search-icon-project-green.png',
        }));
        return items;
    }
    /**
     * Adds builder results to the search result list.
     * @param {string} text - The search text entered by the user.
     * @returns {Promise<void>}
     */
    async fetchBuildersItems(text, token) {
        var _a;
        const url = `/api/ev-results-search-builders?text=${encodeURIComponent(text)}`;
        let res;
        try {
            res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        }
        catch {
            return [];
        }
        if (token !== this.searchToken)
            return [];
        if (!res.ok)
            return [];
        let data;
        try {
            data = await res.json();
        }
        catch {
            return [];
        }
        const tipo = this.stringTipo(this.data.tipo_select);
        const items = ((_a = data === null || data === void 0 ? void 0 : data.Items) !== null && _a !== void 0 ? _a : []).map((item) => {
            var _a;
            let url = item.field_url;
            if (tipo !== 'all') {
                url = this.updateUrlForTipoSelect(url);
            }
            const name = Array.isArray(item.field_name) ? item.field_name[0] : String((_a = item.field_name) !== null && _a !== void 0 ? _a : '');
            return {
                title: name,
                url,
                subtitle: 'Constructora',
                iconUrl: '/themes/custom/ev_theme/assets/images/search_icons/search-icon-builder-green.png',
            };
        });
        return items;
    }
    /**
     * Updates the URL based on the selected search type.
     * @param {string} url - The original URL.
     * @returns {string} - The updated URL with the selected search type.
     */
    updateUrlForTipoSelect(url) {
        if (this.stringTipo(this.data.tipo_select) !== 'all') {
            return url.replace('/projects/all', `/property_type/${this.data.tipo_select}`);
        }
        else {
            const urlPosition = url.split('/')[3];
            return url.replace(`/property_type/${urlPosition}`, '/projects/all');
        }
    }
    /**
     * Renders the search results list in the DOM.
     * @param {Array} items - The search result items.
     * @returns {void}
     */
    renderList(items) {
        if (!this.homeList)
            return;
        this.homeList.innerHTML = '';
        const frag = document.createDocumentFragment();
        const isAttributes = !!this.attributesList;
        const isSelectForm = isAttributes && this.homeList.id.includes('selectListForm');
        for (const item of items) {
            const listItem = document.createElement('li');
            const anchor = document.createElement('a');
            const contentDiv = document.createElement('div');
            const subtitleDiv = document.createElement('span');
            const titleDiv = document.createElement('span');
            listItem.className = 'search__results-list__item';
            anchor.className = 'search__results-list__item__link';
            contentDiv.className = 'search__results-list__item__link__content';
            subtitleDiv.className = 'search__results-list__item__link__content__subtitle';
            titleDiv.className = 'search__results-list__item__link__content__title';
            subtitleDiv.textContent = item.subtitle;
            titleDiv.textContent = item.title;
            if (isAttributes) {
                anchor.id = item.title;
                anchor.setAttribute('data-url', item.url);
                anchor.setAttribute('data-zone', item.subtitle);
                anchor.onclick = (event) => {
                    event.stopPropagation();
                    const dataValue = this.selectCity(this.homeList, this.searchInput, anchor);
                    setUbicationIDData(dataValue);
                    setUbicationData(dataValue);
                    if (!isSelectForm)
                        document.getElementById('nextBtn3').style.display = 'block';
                };
            }
            else {
                anchor.href = item.url;
            }
            const showIcon = !(isAttributes && isSelectForm);
            if (showIcon) {
                const icon = document.createElement('img');
                icon.src = item.iconUrl;
                icon.className = 'search__results-list__item__link__icon';
                icon.alt = 'Vivienda de tipo';
                icon.title = 'Vivienda de tipo';
                anchor.appendChild(icon);
            }
            contentDiv.appendChild(subtitleDiv);
            contentDiv.appendChild(titleDiv);
            anchor.appendChild(contentDiv);
            listItem.appendChild(anchor);
            frag.appendChild(listItem);
        }
        this.homeList.appendChild(frag);
    }
    /**
     * Method to gather the form data.
     * @param {HTMLElement} homeList - The homeList Element.
     * @param {HTMLInputElement} searchInput - The searchInput InputElement.
     * @param {HTMLInputElement} anchor - The anchor HTMLElement.
     * @returns {searchInterface} An object of type searchInterface containing the form information.
     */
    selectCity(homeList, searchInput, anchor) {
        let id = (anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute("id")) || '';
        let zone = (anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute("data-zone")) || '';
        let ubication = zone ? zone === null || zone === void 0 ? void 0 : zone.split(" - ") : '';
        homeList.classList.add('d-none');
        searchInput.value = id;
        searchInput.classList.add('valid');
        searchInput.classList.remove('invalid');
        let zoneLenght = ubication === null || ubication === void 0 ? void 0 : ubication.length;
        let ciudad = zoneLenght == 0 ? id : ubication[0];
        let zona_interes = ubication[1] ? ubication[1] : '';
        let sector_interes = zoneLenght != 0 ? id : '';
        let url = (anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute("data-url")) || '';
        let codesList = url.split('/');
        let cityID = codesList[5];
        let zoneID = codesList[6];
        let sectorID = codesList[7];
        return {
            ciudad: ciudad,
            zona_interes: zona_interes,
            sector_interes: sector_interes,
            cityID: cityID,
            zoneID: zoneID,
            sectorID: sectorID,
        };
    }
    /**
     * Returns the subtitle for a specific sector.
     * @param {number} sector - The sector ID.
     * @returns {string} - The corresponding subtitle for the sector.
     */
    subTitleSector(sector) {
        let stringsector = '';
        if (sector > 0) {
            let sector_select = this.data.facets['sector'].find((x) => x.tid === sector);
            let zona_select = this.data.facets['zone'].find((x) => x.tid === (sector_select === null || sector_select === void 0 ? void 0 : sector_select.parent));
            let ciudad_select = zona_select ? this.data.facets['city'].find((x) => x.tid === zona_select.parent) : undefined;
            stringsector = zona_select ? `${stringsector}${ciudad_select === null || ciudad_select === void 0 ? void 0 : ciudad_select.label} - ${zona_select.label}` : `${stringsector}${ciudad_select === null || ciudad_select === void 0 ? void 0 : ciudad_select.label}`;
        }
        return stringsector;
    }
    /**
     * Adds the necessary event listeners for 'keydown' and 'click' events.
     * @returns {void}
     */
    addEventListeners() {
        var _a, _b, _c, _d;
        /**
         * Listens for the 'keydown' event and hides the search results list when the 'Escape' key (key code 27) is pressed.
         * @param {KeyboardEvent} event - The keyboard event triggered by a key press.
         * @returns {void}
         */
        document.addEventListener('keydown', (event) => {
            let keyCode = event.keyCode;
            if (keyCode === 27 && this.homeList) {
                this.homeList.classList.add('d-none');
            }
        });
        /**
         * Listens for the 'click' event and hides the search results list if the click occurs outside of the list.
         * @param {MouseEvent} event - The mouse event triggered by a click action.
         * @returns {void}
         */
        document.addEventListener('click', (event) => {
            var _a, _b, _c, _d;
            const value = event.target.id;
            if (this.homeList && !this.homeList.contains(event.target) && value !== 'searchHomeInput') {
                this.homeList.classList.add('d-none');
            }
            else {
                let homeListLi = ((_a = this.homeList) === null || _a === void 0 ? void 0 : _a.querySelectorAll('li')) || HTMLElement;
                if (((_b = this.homeList) === null || _b === void 0 ? void 0 : _b.classList.contains('d-none')) && (homeListLi === null || homeListLi === void 0 ? void 0 : homeListLi.length) > 0) {
                    (_c = this.homeList) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
                    (_d = this.homeList) === null || _d === void 0 ? void 0 : _d.classList.add('d-block');
                }
            }
        });
        (_a = document.getElementById('banner-search-form')) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', (event) => {
            event.preventDefault();
        });
        (_b = document.getElementById('advisor-back-btn')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
            const aviTab = document.getElementById('avi-tab');
            const searchTab = document.getElementById('search-tab');
            const aviTabPane = document.getElementById('avi-tab-pane');
            const searchTabPane = document.getElementById('search-tab-pane');
            aviTab === null || aviTab === void 0 ? void 0 : aviTab.classList.add('active');
            searchTab === null || searchTab === void 0 ? void 0 : searchTab.classList.remove('active');
            aviTabPane === null || aviTabPane === void 0 ? void 0 : aviTabPane.classList.add('active', 'show');
            searchTabPane === null || searchTabPane === void 0 ? void 0 : searchTabPane.classList.remove('active', 'show');
        });
        (_c = document.getElementById('search-tab')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
            const iframe = document.querySelector('#avi-chat-frame.open');
            const bannerTabs = document.querySelector('.banner__tabs');
            const titleTab = document.getElementById("title-chat");
            const titleTabOpen = document.getElementById("title-chat-open");
            bannerTabs === null || bannerTabs === void 0 ? void 0 : bannerTabs.classList.add('show-search');
            if (iframe) {
                iframe === null || iframe === void 0 ? void 0 : iframe.classList.remove('show-chat');
                titleTab === null || titleTab === void 0 ? void 0 : titleTab.classList.remove('d-none');
                titleTabOpen === null || titleTabOpen === void 0 ? void 0 : titleTabOpen.classList.add('d-none');
            }
        });
        (_d = document.getElementById('avi-tab')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', () => {
            const iframe = document.querySelector('#avi-chat-frame.open');
            const bannerTabs = document.querySelector('.banner__tabs');
            const titleTab = document.getElementById("title-chat");
            const titleTabOpen = document.getElementById("title-chat-open");
            bannerTabs === null || bannerTabs === void 0 ? void 0 : bannerTabs.classList.remove('show-search');
            if (iframe) {
                iframe === null || iframe === void 0 ? void 0 : iframe.classList.add('show-chat');
                titleTab === null || titleTab === void 0 ? void 0 : titleTab.classList.add('d-none');
                titleTabOpen === null || titleTabOpen === void 0 ? void 0 : titleTabOpen.classList.remove('d-none');
            }
        });
    }
}
